import AnnouncementBanner from './AnnouncementBanner'
import CustomHtml from './CustomHtml'
import ImageWithText from './ImageWithText'
import InstagramFeed from './InstagramFeed'
import Products from './Products'
import PromotionFilmstrip from './PromotionFilmstrip'
import SlideshowBanner from './SlideshowBanner'
import Promotions from './Promotions'
import MarketingPopup from './MarketingPopup'
import Reservations from './Reservations'
import WideBanner from './WideBanner'

export default {
  'announcement-banner': AnnouncementBanner,
  'custom-html': CustomHtml,
  'image-with-text': ImageWithText,
  'instagram-feed': InstagramFeed,
  products: Products,
  'promotion-filmstrip': PromotionFilmstrip,
  'slideshow-banner': SlideshowBanner,
  promotions: Promotions,
  'marketing-popup': MarketingPopup,
  'reservationsPage': Reservations,
  'removableReservation': Reservations,
  'wide-banner': WideBanner
}
